module.exports = __webpack_public_path__ + "static/media/Speed.2bd54dd8.mp4";